import { Injectable } from '@angular/core';
import {
  ModalOptions,
  AlertService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { StorageServiceObservablesService } from './../../_services/storage-service-observables/storage-service-observables.service';
import { AgentNotificationService } from './../../_services/agent/agent-notification.service';
import { PaperlessService } from './../../_services/_iam/paperless.service';
import { AppRatingService } from './../../_services/pwa-service/app-rating.service';
import { PolicyDataService } from './../../_services/data-services/policy-data.service';
import { PolicyDetailsService } from './../../_services/my-insurance/policy-details.service';
import { ErrorRedirectionService } from './../../_services/error-service/error-redirection.service';
import { CustomerProfileService } from './../../_services/customer-profile/customer-profile.service';
import _ from 'underscore';

import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { Constants } from '@models/constants';

@Injectable({
  providedIn: 'root',
})
export class PaperlessDataService {
  removalEnroll: ModalOptions;
  emailaddress: string;
  enrollModel: ModalOptions;
  loader = false;
  loading = true;
  confirmModal: boolean;
  policyInfo: any;
  allAs400Policies: any = [];
  where: string;
  allLivoPolicies: any = [];
  onRemovePolicy: any;
  policyJurisdictionState: string;
  isAcmic: boolean;
  constructor(
    private agentNotification: AgentNotificationService,
    private alertService: AlertService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private router: Router,
    private gTagService: GTagService,
    private appRatingService: AppRatingService,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private acmicService: AcmicService,
    private customerProfileService: CustomerProfileService,
    private errorRedirectionService: ErrorRedirectionService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyInfo = policyResponse;
        this.allAs400Policies = this.as400policy(policyResponse);
        this.allLivoPolicies = this.livoPolicy(policyResponse);
        this.checkAllPoliciesForEligibilty();
        this.loading = false;
      }
    });
  }

  as400policy(policyResponse) {
    return _.filter(policyResponse, (policy) => {
      return (
        policy.policynumber.policyNumber.length == 6 &&
        policy.policyStatus == 'ACTIVE' &&
        new Date(policy.effDate) <= new Date()
      );
    });
  }

  livoPolicy(policyResponse) {
    return _.filter(policyResponse, (policy) => {
      return (
        policy.policynumber.policyNumber.length > 6 &&
        policy.policyStatus == 'ACTIVE' &&
        new Date(policy.effDate) <= new Date()
      );
    });
  }

  waStatepolicy(policyResponse) {
    return _.filter(policyResponse, (policy) => {
      return (
        policy.policyStatus == 'ACTIVE' && policy.jurisdiction.state == 'WA'
      );
    });
  }
  isAllPolicyEligible() {
    return _.pluck(this.policyInfo, 'policyStatus').includes('ACTIVE');
  }

  checkAllPoliciesForEligibilty(): boolean {
    let allPoliciesEligible = false;
    this.policyInfo.forEach((policy) => {
      if (policy.policyFlags.length == 0) {
        allPoliciesEligible = false;
      } else {
        if (
          policy.policyFlags.isEbillEligible == 'N' &&
          policy.policyFlags.isEdfEligible == 'N'
        ) {
          allPoliciesEligible = allPoliciesEligible
            ? allPoliciesEligible
            : false;
        } else {
          allPoliciesEligible = allPoliciesEligible
            ? allPoliciesEligible
            : true;
        }
      }
    });
    if (!this.isAllPolicyEligible()) {
      allPoliciesEligible = false;
    }
    return allPoliciesEligible;
  }

  getRemovalModel(
    additionalClass?: string,
    additionalButtonClass?: string,
    buttonCopy?: string,
    modalID?: string,
    modalTranslateCopy?: string
  ) {
    this.removalEnroll = new ModalOptions({
      additionalClasses: additionalClass,
      additionalButtonClasses: additionalButtonClass,
      animatePosition: 'top',
      buttonCopy,
      modalId: modalID,
      howManyIconsUsed: 1,
      iconClasses: 'far fa-times-circle',
      modalTranslateCopy,
      screenReader: true,
      showIcons: true,
      modalName: 'paperless_Enroll_Removal',
    });
    return this.removalEnroll;
  }

  getEnrollModel(
    classes?: string,
    btnClass?: string,
    btnCopy?: string,
    modalID?: string,
    modalTranslateCopy?: string
  ) {
    this.enrollModel = new ModalOptions({
      additionalClasses: classes,
      additionalButtonClasses: btnClass,
      animatePosition: 'top',
      buttonCopy: btnCopy,
      modalId: modalID,
      modalTranslateCopy,
      modalName: 'paperless_Enroll',
    });
    return this.enrollModel;
  }

  showToast() {
    this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
    if (this.isAcmic && this.policyJurisdictionState === 'WA') {
      this.router.navigate([Constants.BILLING_PAPERLESS_END_WITH_SLASH]);
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
  }

  enroll(policy, where): void {
    this.policyJurisdictionState = policy.jurisdiction.state;
    this.agentNotification.setAgentInfo(policy);
    this.agentNotification.setHeader(policy);
    if (
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] <= 30 &&
        policy.policynumber.policyNumber.length === 6 &&
        policy.livoPolicy) ||
      policy.underConversion ||
      (policy &&
        policy['days_left_to_expire'] &&
        policy['days_left_to_expire'] == -1 &&
        policy.policynumber.policyNumber.length == 6) ||
      policy['isNewPolicy']
    ) {
      this.showToast();
    } else {
      const email = this.storageServiceObservablesService.getUserFromStorage();
      this.loader = true;
      if (where == 'e-policy') {
        this.paperlessService
          .enrollPaperlessEPolicyV2(policy.policynumber.policyNumber, email)
          .subscribe(
            () => {
              this.enrollSuccess(policy, where);
              this.gTagService.triggerFormLink(
                'enrollPaperlessEPolicy',
                'true',
                ''
              );
              if (Capacitor.isNativePlatform()) {
                this.appRatingService.rateApp();
              }
            },
            (errorRes) => {
              this.enrollError(errorRes, policy.policynumber.policyNumber);
              this.gTagService.triggerFormLink(
                'enrollPaperlessEPolicy',
                'false',
                'enroll paperless epolicy error'
              );
            }
          );
      } else if (where == 'e-bill') {
        this.paperlessService
          .enrollPaperlessEBill(policy.policynumber.policyNumber, email)
          .subscribe(
            () => {
              this.enrollSuccess(policy, where, email);
            },
            (errorRes) => {
              this.enrollError(errorRes, policy.policynumber.policyNumber);
            }
          );
      }
    }
  }

  errorHandler(error, policyid) {
    if (
      error.status === 400 ||
      error.status === 401 ||
      error.status === 403 ||
      error.status === 404 ||
      error.status === 408
    ) {
      if (policyid.length === 6) {
        this.alertService.error('PROBLEM_IN_REQUEST_PROCESSING');
        if (this.isAcmic && this.policyJurisdictionState === 'WA') {
          this.router.navigate([Constants.BILLING_PAPERLESS_END_WITH_SLASH]);
        } else {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }
      }
    } else {
      this.errorRedirectionService.errorRedirectHandler(error, policyid);
    }
  }

  enrollError(errorRes, policyId) {
    this.loader = false;
    if (this.isAcmic && this.policyJurisdictionState === 'WA') {
      this.router.navigate([Constants.BILLING_PAPERLESS_END_WITH_SLASH]);
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
    this.errorHandler(errorRes, policyId);
  }

  reSync(email): void {
    this.loading = true;
    this.policyDataService.clear();
    this.policyDetailsService.getPolicyDetailsByEmail(email).subscribe(
      () => {
        //do nothing
      },
      (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );
    if (this.isAcmic && this.policyJurisdictionState === 'WA') {
      this.router.navigate([Constants.BILLING_PAPERLESS_END_WITH_SLASH]);
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
  }
  enrollSuccessMessage(policy, where) {
    const title = `You've enrolled successfully!`;
    const policyType = policy?.displayType?.label
      ? policy.displayType.label.toLowerCase()
      : 'policy';
    const youhave = `Your ${policyType} policy`;
    const allow = 'Allow up to 2 business days for processing.';
    if (policy.policynumber.policyNumber.length === 6) {
      if (where == 'e-policy') {
        this.alertService.success(
          `${youhave} ${policy.policynumber.policyNumber} is successfully enrolled in e-Policy. ${allow}`,
          false,
          title
        );
      } else if (where == 'e-bill') {
        this.alertService.success(
          `${youhave} ${policy.policynumber.policyNumber} is successfully enrolled in E-bill.`,
          false,
          title
        );
      }
    } else {
      this.alertService.success(
        `${youhave} ${policy.policynumber.policyNumber} is successfully enrolled in paperless.`,
        this.policyJurisdictionState === 'WA',
        title
      );
    }
  }
  enrollSuccess(policy, where, email?) {
    this.loader = false;
    this.enrollSuccessMessage(policy, where);
    if (where == 'e-policy') {
      this.updatePolicyInfo(policy, 'ENROLL', where);
    } else if (where == 'e-bill') {
      this.reSync(email);
    }
    if (this.isAcmic && this.policyJurisdictionState === 'WA') {
      this.router.navigate([Constants.BILLING_PAPERLESS_END_WITH_SLASH]);
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
    if (policy.policynumber.policyNumber.length === 10) {
      this.customerProfileService.setModalTitle('PAPERLESS');
    }
  }
  updatePolicyInfo(policy, Type, where) {
    if (policy && policy.policynumber.policyNumber.length == 6) {
      for (let i = 0; i < this.allAs400Policies.length; i++) {
        if (
          this.allAs400Policies[i].policynumber.policyNumber ===
          policy.policynumber.policyNumber
        ) {
          if (where == 'e-policy') {
            this.allAs400Policies[i].policyFlags.isEdf =
              Type === 'ENROLL' ? 'ENROLLMENT-PENDING' : 'UNENROLLMENT-PENDING';
          } else if (where == 'e-bill') {
            this.allAs400Policies[i].policyFlags.isEbill =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          }
        }
      }
    } else if (policy && policy.policynumber.policyNumber.length > 6) {
      for (let i = 0; i < this.allLivoPolicies.length; i++) {
        if (
          this.allLivoPolicies[i].policynumber.policyNumber ===
          policy.policynumber.policyNumber
        ) {
          if (where == 'e-policy') {
            this.allLivoPolicies[i].policyFlags.isEdf =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          } else if (where == 'e-bill') {
            this.allLivoPolicies[i].policyFlags.isEbill =
              Type === 'ENROLL' ? 'TRUE' : 'FALSE';
          }
        }
      }
    }
  }
}
